class StickyObserver {
  constructor(selector) {
    this.stickyEls = document.querySelectorAll(selector);
    this.init();
  }

  init() {
    this.stickyEls.forEach((el) => {
      const parent = el.parentElement;
      parent.style.position = 'relative';

      // Top sentinel
      const topSentinel = document.createElement('div');
      Object.assign(topSentinel.style, {
        position: 'absolute',
        top: '0',
        height: '1px',
        width: '1px',
        pointerEvents: 'none',
      });
      parent.prepend(topSentinel);

      // Bottom sentinel
      const bottomSentinel = document.createElement('div');
      Object.assign(bottomSentinel.style, {
        position: 'absolute',
        bottom: '0',
        height: '1px',
        width: '1px',
        pointerEvents: 'none',
      });
      parent.append(bottomSentinel);

      const topObserver = new IntersectionObserver(
        ([entry]) => {
          // Add when scrolled past, remove when scrolled back up
          el.classList.toggle('is-stuck', !entry.isIntersecting);
        },
        { threshold: [0], rootMargin: '-1px 0px 0px 0px' }
      );

      const bottomObserver = new IntersectionObserver(
        ([entry]) => {
          // Remove when parent is out of view
          if (entry.isIntersecting) {
            el.classList.remove('is-stuck');
          }
        },
        { threshold: [0] }
      );

      topObserver.observe(topSentinel);
      bottomObserver.observe(bottomSentinel);
    });
  }
}

const sticky = new StickyObserver('.sticky-heading');

// Case Studies Filter
document.addEventListener('DOMContentLoaded', function () {
  const filters = document.querySelectorAll('.cs-filter');
  const groups = document.querySelectorAll('.cs-group');

  filters.forEach(function (filter) {
    filter.addEventListener('click', function () {
      const category = this.dataset.category;

      // Update active state
      filters.forEach((f) => f.classList.remove('active'));
      this.classList.add('active');

      // Show/hide groups
      groups.forEach(function (group) {
        group.style.display = group.dataset.category === category ? 'block' : 'none';
      });

      // Scroll to top of page
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });
});

// Marquee Effect
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.testimonial-marquee-wrapper');
  const marquee = document.querySelector('.testimonial-marquee');

  if (!wrapper || !marquee) return;

  const innerContainer = wrapper.querySelector('.wp-block-group__inner-container');
  if (innerContainer) {
    innerContainer.style.maxWidth = 'none';
    innerContainer.style.padding = '0';
    innerContainer.style.overflow = 'visible';
  }

  const items = Array.from(marquee.querySelectorAll('li'));

  // Clone items THREE times for full coverage both directions
  for (let i = 0; i < 3; i++) {
    items.forEach(function (item) {
      const clone = item.cloneNode(true);
      marquee.appendChild(clone);
    });
  }

  // Also prepend clones for reverse scrolling
  for (let i = 0; i < 2; i++) {
    items.reverse().forEach(function (item) {
      const clone = item.cloneNode(true);
      marquee.prepend(clone);
    });
    items.reverse(); // restore original order
  }

  // Calculate width of one set
  let singleSetWidth = 0;
  items.forEach(function (item) {
    const gap = parseFloat(window.getComputedStyle(marquee).gap) || 0;
    singleSetWidth += item.offsetWidth + gap;
  });

  // Start from the prepended clones offset
  let position = -singleSetWidth * 2;
  let speed = 0.5; // pixels per frame
  let isDragging = false;
  let startX;
  let scrollLeft;
  let velocity = 0;
  let lastX = 0;
  let lastTime = 0;

  function wrapPosition() {
    // Scrolling left (normal direction)
    if (position <= -singleSetWidth * 3) {
      position += singleSetWidth;
    }
    // Scrolling right (reverse direction)
    if (position >= -singleSetWidth) {
      position -= singleSetWidth;
    }
  }

  function animate() {
    if (!isDragging) {
      position -= speed;
      wrapPosition();
      marquee.style.transform = 'translateX(' + position + 'px)';
    }
    requestAnimationFrame(animate);
  }

  // Set initial position
  marquee.style.transform = 'translateX(' + position + 'px)';
  animate();

  // Mouse events
  wrapper.addEventListener('mousedown', function (e) {
    isDragging = true;
    startX = e.pageX;
    scrollLeft = position;
    lastX = e.pageX;
    lastTime = Date.now();
    velocity = 0;
  });

  wrapper.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    e.preventDefault();

    const x = e.pageX;
    const now = Date.now();
    const dt = now - lastTime || 1;

    velocity = (x - lastX) / dt;
    lastX = x;
    lastTime = now;

    position = scrollLeft + (x - startX);
    wrapPosition();
    marquee.style.transform = 'translateX(' + position + 'px)';
  });

  wrapper.addEventListener('mouseup', function () {
    isDragging = false;
    applyMomentum();
  });

  wrapper.addEventListener('mouseleave', function () {
    if (isDragging) {
      isDragging = false;
      applyMomentum();
    }
  });

  // Touch events
  wrapper.addEventListener('touchstart', function (e) {
    isDragging = true;
    startX = e.touches[0].pageX;
    scrollLeft = position;
    lastX = e.touches[0].pageX;
    lastTime = Date.now();
    velocity = 0;
  });

  wrapper.addEventListener('touchmove', function (e) {
    if (!isDragging) return;

    const x = e.touches[0].pageX;
    const now = Date.now();
    const dt = now - lastTime || 1;

    velocity = (x - lastX) / dt;
    lastX = x;
    lastTime = now;

    position = scrollLeft + (x - startX);
    wrapPosition();
    marquee.style.transform = 'translateX(' + position + 'px)';
  });

  wrapper.addEventListener('touchend', function () {
    isDragging = false;
    applyMomentum();
  });

  function applyMomentum() {
    function decelerate() {
      if (Math.abs(velocity) < 0.01) return;
      velocity *= 0.95;
      position += velocity * 16;
      wrapPosition();
      marquee.style.transform = 'translateX(' + position + 'px)';
      requestAnimationFrame(decelerate);
    }
    decelerate();
  }

  // Recalculate on resize
  window.addEventListener('resize', function () {
    singleSetWidth = 0;
    items.forEach(function (item) {
      const gap = parseFloat(window.getComputedStyle(marquee).gap) || 0;
      singleSetWidth += item.offsetWidth + gap;
    });
  });
});
